import { Button } from '@chakra-ui/react';
import { globalStyles } from 'common/theme/styles';
import 'common/assets/css/outlined-btn.css'

const OutlinedIconBtn = (props) => {
    const { onClick, title, disabled = false , leftIcon, rightIcon, borderColor, color, width='fit-content', justifyContent="", background='var(--chakra-colors-white)' } = props
    const colors = globalStyles.colors;

    return (
        <>
            <Button opacity={disabled ? '0.4' : ''} cursor={disabled ? 'not-allowed' : 'pointer'} background={background} justifyContent={justifyContent}  width={width} onClick={onClick} className='customOutlined-btn' sx={{
                color: `${color ? color : colors.text['200']}`,
                borderColor: `${borderColor ? borderColor : colors.borderColor}`
            }} leftIcon={leftIcon} rightIcon={rightIcon}>
                {title && title}
            </Button>
        </>
    )
}

export default OutlinedIconBtn